module.exports = __webpack_public_path__ + "static/media/Projektbesuch_Cancel.4a3967d4.png";